import { ToyTypeAction, ToyTypes } from './Types';
import {  ToyInitialStateType ,issueMessage} from './Interface';

const initialState: ToyInitialStateType = {
	isLoading: false
};

export const toyReducer = (state = initialState, action: ToyTypeAction) => {
	switch (action.type) {
		case ToyTypes.LOAD_TOY:
			// eslint-disable-next-line no-console
			console.log(action.payload.data,"fgk,,,,")
			return {
				...state,
				toy: action.payload.data,
				// showQue:action.payload.data,
				error:undefined,
				message:undefined
			};
		case ToyTypes.ERROR_TOY:
			// eslint-disable-next-line no-console
			console.log("hu",action.payload.data)
			return {
				...state,
				error:action.payload.data
			}
		case ToyTypes.ISSUE:
			return {
				...state,
				// error: action.payload.errors,
				message: action.payload.data
			};
		case ToyTypes.POST_QUESTIONNAIRE:
			return {
				...state,
				toy:undefined
			};
		case ToyTypes.FETCH_QUESTIONNAIRE:
			return {
				...state,
				toyQuestionnaire:action.payload.data
			}
		case ToyTypes.GENERATE_NEW_TOY:
			return{
				...state
			}
		default:
			return state;
	}
};
